(function() {
    'use strict';

    angular
        .module('remitEventsApp')
        .factory('stateHandler', function stateHandler(
            $rootScope,
            $stateParams,
            $transitions,
            $translate,
            $window,
            Auth,
            HelpersService,
            Language,
            Principal 
        ) {
            function initialize() {
                $transitions.onStart({}, function(trans) {
                    $rootScope.fromState = trans.from();
                    $rootScope.toState = trans.to();
                    $rootScope.toStateParams = trans.params();

                    if (Principal.isIdentityResolved()) {
                        Auth.authorize();
                    }

                    HelpersService.clearPrevData();

                    Language.getCurrent().then(function(language) {
                        $translate.use(language);
                        moment.locale(language);
                    });
                });

                $transitions.onSuccess({}, function(trans) {
                    var toState = trans.to();
                    var fromState = trans.from();
                    var fromParams = $stateParams;
                    var titleKey = 'global.title';

                    if (toState.name !== 'login' && $rootScope.previousStateName) {
                        $rootScope.previousStateName = fromState.name;
                        $rootScope.previousStateParams = fromParams;
                    }

                    if (toState.data.pageTitle) {
                        titleKey = toState.data.pageTitle;
                    }

                    $translate(titleKey).then(function(title) {
                        $window.document.title = title;
                    });
                });
            }

            return {
                initialize: initialize
            };
        });
})();
